import React, { FC } from "react";
import { FormControl as MuiFormControl } from "@mui/material";

type Props = React.ComponentProps<typeof MuiFormControl>;

const FormControl: FC<Props> = (props) => {
    return <MuiFormControl {...props}/>
}

export default FormControl;